import app from 'flarum/forum/app';

/**
 * Muestra una sola vez el resultado del POST de confirmacion de correo.
 *
 * El controlador deja una marca flash en la sesion y `AddAccountActivationPayload` la consume
 * al construir el primer HTML del foro tras el redirect. Se borra tambien del payload local
 * para que una inicializacion defensiva repetida en la misma pagina no duplique el aviso.
 */
export default function showActivationToast(): void {
  if (app.data.umbralAccountActivated !== true) return;

  app.data.umbralAccountActivated = false;

  app.alerts.show(
    {
      type: 'success',
      title: app.translator.trans('umbral-comunidad.forum.confirm.done_title'),
    },
    app.translator.trans('umbral-comunidad.forum.confirm.done_body')
  );
}
